import { useTranslation } from "react-i18next";
import { DashboardHeader } from "./components/header/dashboard-header";
import { Navbar } from "./components/navbar";
import { DashboardContent } from "./components/content/dashboard-content";
import { Footer } from "./components/footer";

export const DashboardPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="max-w-7xl mx-auto min-h-screen flex flex-col justify-between">
      <div>
        <Navbar />
        <main className="px-4 md:px-6 py-6 md:py-8 max-w-7xl mx-auto gap-4 flex flex-col">
          <span className="text-2xl text-text-primary">
            {t("dashboard.title")}
          </span>
          <DashboardHeader />

          <span className="text-xl text-text-primary">
            {t("dashboard.contentTitle")}
          </span>
          <DashboardContent />
        </main>
      </div>
      <Footer />
    </div>
  );
};
